// ChartViewCompact.jsx

import React from 'react';

// Components
import ChartView from './ChartView';

/**
 * ChartViewCompact
 *
 * Compact chart renderer for constrained surfaces (e.g. dashboard cards).
 *
 * @returns {ReactNode} The rendered component.
 */
const ChartViewCompact = React.memo(({ view, typeDef, nodes = [] }) => {

  // ----- RENDER ----- //

  return (
    <ChartView
      view={view}
      typeDef={typeDef}
      nodes={nodes}
      displayMode="compact"
    />
  );
});

// Dev Tools
ChartViewCompact.displayName = 'ChartViewCompact';

export default ChartViewCompact;
